<div class="tw-flex tw-items-center tw-flex-wrap tw-gap-[8px]">
  <ng-content select="[formControlName='monthlyRecurrenceConfigType']"/>
  <ng-content select="[formControlName='monthlyRecurrenceConfigDay']"/>
  <span>{{ 'iss-wo-common.recurrence-schedule.labels.of-every' | translate }}</span>
  <ng-content/>
  <span>{{ 'iss-wo-common.recurrence-schedule.every-recurrence-type.month' | translate }}</span>
</div>
